import { Component, OnInit } from '@angular/core';
import { AccountService } from '../account.service';
import { Router } from '@angular/router';
import { SnackbarService } from '../../services/snackbar.service';
@Component({
  selector: 'app-log-out',
  templateUrl: './log-out.component.html',
  styleUrls: ['./log-out.component.scss']
})
export class LogOutComponent implements OnInit {

  constructor(private accountService: AccountService, private router: Router, public snackbarService: SnackbarService) { }

  ngOnInit(): void {
    this.accountService.clearSession('').subscribe((data:any) => {
          this.openSnackbar(data['message']);
          localStorage.removeItem('userdata')
          sessionStorage.removeItem('userdata')
          //this.router.navigate(['/auth/login-selection']);
        }
          , error => {
            let message = error.error || error.error[0];
            this.openSnackbar(message.error);
          })
  }

openSnackbar(message: string) {
  this.snackbarService.open(message);
}

}


